var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHistorySvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 460 460",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1016_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1017_",
    style: {
      fill: "#FE843F"
    },
    d: "M451.868,170.271c0.016,0.057,0.138,0.12,0.333,0.186 C425.963,72.298,336.432,0,230,0C102.974,0,0,102.974,0,230c0,105.83,71.482,194.951,168.794,221.751L451.868,170.271z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1018_",
    style: {
      fill: "#FC5A37"
    },
    d: "M460,230c0-19.519-2.441-38.467-7.017-56.563 c-0.463-1.107-0.841-2.166-1.114-3.166L371.82,90.223L100,382.957l68.794,68.794C188.284,457.118,208.804,460,230,460 C357.026,460,460,357.025,460,230z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1019_",
    style: {
      fill: "#FFF2D4"
    },
    points: "340,227.632 340,347.957 230,357.957 230,227.632 285,217.632  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1020_",
    x: 230,
    y: 192.632,
    style: {
      fill: "#FFC85F"
    },
    width: 110,
    height: 35
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1021_",
    style: {
      fill: "#FFE278"
    },
    points: "340,122.043 340,192.632 230,192.632 230,122.043 285,112.043  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1022_",
    x: 230,
    y: 77.043,
    style: {
      fill: "#FFC85F"
    },
    width: 110,
    height: 45
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1023_",
    style: {
      fill: "#FFFFFF"
    },
    points: "230,227.632 230,357.957 120,347.957 120,227.632 175,217.632  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1024_",
    x: 120,
    y: 192.632,
    style: {
      fill: "#FFE278"
    },
    width: 110,
    height: 35
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1025_",
    style: {
      fill: "#FFF2D4"
    },
    points: "230,122.043 230,192.632 120,192.632 120,122.043 175,112.043  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1026_",
    x: 120,
    y: 77.043,
    style: {
      fill: "#FFE278"
    },
    width: 110,
    height: 45
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1027_",
    style: {
      fill: "#FFE278"
    },
    d: "M183.75,279.793v78.164h-35v-78.164c0-9.66,7.84-17.5,17.5-17.5 C175.919,262.293,183.75,270.133,183.75,279.793z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1028_",
    style: {
      fill: "#FFC85F"
    },
    d: "M247.5,279.793v78.164h-35v-78.164c0-9.66,7.84-17.5,17.5-17.5 C239.669,262.293,247.5,270.133,247.5,279.793z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1029_",
    style: {
      fill: "#FFC85F"
    },
    d: "M311.25,279.793v78.164h-35v-78.164c0-9.66,7.84-17.5,17.5-17.5 C303.419,262.293,311.25,270.133,311.25,279.793z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1030_",
    style: {
      fill: "#FFF2D4"
    },
    d: "M75,122.043c0,24.853,20.147,45,45,45l10-45l-10-45 C95.147,77.043,75,97.19,75,122.043z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1031_",
    style: {
      fill: "#FFE278"
    },
    d: "M120,77.043v90c24.853,0,45-20.147,45-45S144.853,77.043,120,77.043z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1032_",
    style: {
      fill: "#FFFFFF"
    },
    cx: 120,
    cy: 122.043,
    r: 22.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1033_",
    style: {
      fill: "#FFE278"
    },
    d: "M295,122.043c0,24.853,20.147,45,45,45l10-45l-10-45 C315.147,77.043,295,97.19,295,122.043z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1034_",
    style: {
      fill: "#FFC85F"
    },
    d: "M340,77.043v90c24.853,0,45-20.147,45-45S364.853,77.043,340,77.043z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1035_",
    style: {
      fill: "#FFF2D4"
    },
    cx: 340,
    cy: 122.043,
    r: 22.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1036_",
    style: {
      fill: "#FFE278"
    },
    d: "M340,347.957H230v35h130c0,0,0-7.875,0-17.5S351,347.957,340,347.957z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1037_",
    style: {
      fill: "#FFF2D4"
    },
    d: "M120,347.957c-11,0-20,7.875-20,17.5s0,17.5,0,17.5h130v-35H120z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistorySvgrepoCom);
export default __webpack_public_path__ + "static/media/history-svgrepo-com.6054fbc17d1c7652c57c64e8529db0b9.svg";
export { ForwardRef as ReactComponent };